import React, { useEffect, useMemo } from 'react'
import { useFieldArray, useWatch } from 'react-hook-form'
import { AudienceFilter, Group } from './types'
import CombinatorSelector from './CombinatorSelector'
import { Button } from '@demandlocal/components'
import RuleGroup from './RuleGroup'

export default function QueryBuilder({
  onChange,
}: {
  onChange?: () => void
}): React.ReactNode {
  const {
    fields: queryBuilderFields,
    append: appendQueryBuilder,
    remove: removeQueryBuilder,
    update: updateQueryBuilder,
  } = useFieldArray<AudienceFilter>({
    name: 'groups',
  })

  const groups = useWatch({ name: 'groups' })

  const allRulesWithValues = useMemo(
    () =>
      groups?.map((group) => {
        return group?.rules?.filter((rule) => rule.value)
      }),
    [groups],
  )

  useEffect(() => {
    onChange?.()
  }, [allRulesWithValues, onChange])

  const handleGroupRemove = (index: number) => {
    const previousRule = queryBuilderFields?.[index - 1]
    const hasCombinator = previousRule?.type === 'combinator'
    removeQueryBuilder(index)
    if (hasCombinator) removeQueryBuilder(index - 1)
  }

  return (
    <div className={'border-2 border-gainsboro-gray rounded-lg gap-4'}>
      {queryBuilderFields.length > 0 && (
        <div className={'flex flex-col gap-4 p-4 pb-0'}>
          {queryBuilderFields.map((item, index) => {
            if (item.type === 'group') {
              return (
                <RuleGroup key={item.id} index={index} removeGroup={handleGroupRemove} />
              )
            }
            if (item.type === 'combinator')
              return <CombinatorSelector key={item.id} groupIndex={index} />
          })}
        </div>
      )}
      <div className={'flex gap-4 p-4'}>
        <Button
          animate={false}
          leftSlot={
            <div
              className={
                'w-6 h-6 bg-primary-persian-blue rounded-full text-white text-center self-center flex items-center justify-center'
              }>
              R
            </div>
          }
          type="button"
          variant={'secondary'}
          onClick={(e) => {
            e.preventDefault()
            if (queryBuilderFields?.length > 0) {
              appendQueryBuilder({
                type: 'combinator',
                value: 'and',
                label: 'AND',
              })
            }
            appendQueryBuilder({
              type: 'group',
              name: 'Group 1',
              rules: [
                {
                  type: 'filter',
                },
              ],
            })
          }}>
          + Add Rule
        </Button>
      </div>
    </div>
  )
}
